import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Axis } from 'src/app/models/survey/axis';
import { Option } from 'src/app/models/survey/options';
import { Question } from 'src/app/models/survey/question';
import { Survey } from 'src/app/models/survey/survey';
import { SvSection } from 'src/app/models/survey/svsection';
import { AxisService } from 'src/app/services/survey/axis.service';
import { OptionsService } from 'src/app/services/survey/options.service';
import { QuestionTypeService } from 'src/app/services/survey/question-type.service';
import { QuestionService } from 'src/app/services/survey/question.service';
import { SurveyService } from 'src/app/services/survey/survey.service';
import { SvsectionService } from 'src/app/services/survey/svsection.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  form: FormGroup;
  survey: Survey = null;
  svsections: SvSection[] = null;
  answers: { [key: string]: any } = {};
  questions: Question[];
  opts: Option[];
  showModal: boolean = false;
  careers: { id: number, name: string }[] = [
    // Ciencias de la Salud
    { id: 1, name: 'Ciencia de los Alimentos' },
    { id: 2, name: 'Enfermería' },
    { id: 3, name: 'Farmacia y Bioquímica' },
    { id: 4, name: 'Medicina Humana' },
    { id: 5, name: 'Medicina Veterinaria' },
    { id: 6, name: 'Nutrición' },
    { id: 7, name: 'Obstetricia' },
    { id: 8, name: 'Odontología' },
    { id: 9, name: 'Psicología' },
    { id: 10, name: 'Psicología Organizacional y de la Gestión Humana' },
    { id: 11, name: 'Tecnología Médica' },
    { id: 12, name: 'Toxicología' },

    // Ciencias Básicas
    { id: 13, name: 'Ciencias Biológicas' },
    { id: 14, name: 'Computación Científica' },
    { id: 15, name: 'Estadística' },
    { id: 16, name: 'Física' },
    { id: 17, name: 'Genética y Biotecnología' },
    { id: 18, name: 'Investigación Operativa' },
    { id: 19, name: 'Matemática' },
    { id: 20, name: 'Microbiología y Parasitología' },
    { id: 21, name: 'Química' },

    // Ingeniería
    { id: 22, name: 'Ciencia de la Computación' },
    { id: 23, name: 'Ingeniería Agroindustrial' },
    { id: 24, name: 'Ingeniería Ambiental' },
    { id: 25, name: 'Ingeniería Biomédica' },
    { id: 26, name: 'Ingeniería Civil' },
    { id: 27, name: 'Ingeniería de Minas' },
    { id: 28, name: 'Ingeniería de Seguridad y Salud en el Trabajo' },
    { id: 29, name: 'Ingeniería de Sistemas' },
    { id: 30, name: 'Ingeniería de Software' },
    { id: 31, name: 'Ingeniería de Telecomunicaciones' },
    { id: 32, name: 'Ingeniería Eléctrica' },
    { id: 33, name: 'Ingeniería Electrónica' },
    { id: 34, name: 'Ingeniería Geográfica' },
    { id: 35, name: 'Ingeniería Geológica' },
    { id: 36, name: 'Ingeniería Industrial' },
    { id: 37, name: 'Ingeniería Mecánica de Fluidos' },
    { id: 38, name: 'Ingeniería Metalúrgica' },
    { id: 39, name: 'Ingeniería Química' },
    { id: 40, name: 'Ingeniería Textil y Confecciones' },

    // Ciencias Económicas y de la Gestión
    { id: 41, name: 'Administración' },
    { id: 42, name: 'Administración de Negocios Internacionales' },
    { id: 43, name: 'Administración de Turismo' },
    { id: 44, name: 'Auditoría Empresarial y del Sector Público' },
    { id: 45, name: 'Contabilidad' },
    { id: 46, name: 'Economía' },
    { id: 47, name: 'Economía Internacional' },
    { id: 48, name: 'Economía Pública' },
    { id: 49, name: 'Gestión Tributaria' },
    { id: 50, name: 'Presupuesto y Finanzas Públicas' },

    // Humanidades, Ciencias Jurídicas y Sociales
    { id: 51, name: 'Antropología' },
    { id: 52, name: 'Arqueología' },
    { id: 53, name: 'Arte' },
    { id: 54, name: 'Bibliotecología y Ciencias de la Información' },
    { id: 55, name: 'Ciencia Política' },
    { id: 56, name: 'Comunicación Social' },
    { id: 57, name: 'Conservación y Restauración' },
    { id: 58, name: 'Danza' },
    { id: 59, name: 'Derecho' },
    { id: 60, name: 'Educación' },
    { id: 61, name: 'Educación Física' },
    { id: 62, name: 'Filosofía' },
    { id: 63, name: 'Geografía' },
    { id: 64, name: 'Historia' },
    { id: 65, name: 'Lenguas, Traducción e Interpretación' },
    { id: 66, name: 'Lingüística' },
    { id: 67, name: 'Literatura' },
    { id: 68, name: 'Sociología' },
    { id: 69, name: 'Trabajo Social' },

    // Carreras adicionales de UNI
    { id: 70, name: 'Ingeniería Sanitaria' },
    { id: 71, name: 'Ingeniería Mecánica' },
    { id: 72, name: 'Ingeniería de Petróleo' },
    { id: 73, name: 'Arquitectura' }
  ];

  filteredCareers: { id: number, name: string }[] = [];
  isCareersDropdownVisible: boolean = false;

  countries: { id: number, name: string }[] = [];
  states: { id: number, id_country: number, name: string }[] = [];
  filteredCountries: { id: number, name: string }[] = [];
  filteredStates: { id: number, name: string }[] = [];
  selectedCountryId: number = null;
  isCountriesDropdownVisible: boolean = false;
  isStatesDropdownVisible: boolean = false;

  constructor(
    private http: HttpClient,
    private svService: SurveyService,
    private qtService: QuestionTypeService,
    private svsecService: SvsectionService,
    private qService: QuestionService,
    private optService: OptionsService,
    private axService: AxisService,
    private fb: FormBuilder,
    private actRoute: ActivatedRoute) { }
  getGlossaryDetail(): string {
    const glossarySection = this.survey.sections.find(section => section.title === "Glosario de términos");
    return glossarySection ? glossarySection.detail : '';
  }

  ngOnInit() {
    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      /* Consulta por ID de encuesta */
      this.getOneSurvey(params['id']);
    } else if (params['url']) {
      /* Consulta por URL de encuesta */
      this.getOneUrlSurvey(params['url']);
    }
  }

  getOneUrlSurvey(url: string) {
    if (url) {
      this.svService.getOneUrl(url)
        .subscribe(
          res => {
            this.survey = res['data'];
            this.getSvSec4Survey(this.survey);
            console.log("Survey: ", this.survey);
          },
          err => console.error(err)
        );
    } else {
    }
  }

  getOneSurvey(id: string) {
    if (id) {
      this.svService.getOne(id)
        .subscribe(
          res => {
            this.survey = res['data'];
            this.getSvSec4Survey(this.survey);
          },
          err => console.error(err)
        );
    }
  }

  getSvSec4Survey(survey: Survey) {
    if (survey) {
      this.svsecService.get4Survey(survey.id.toString())
        .subscribe(
          res => {
            this.svsections = res['data'];
            if (this.svsections.length > 0) {
              this.survey.sections = this.svsections;
              this.getQuestion4Section(this.survey.sections);
            }
            //this.loadData();
          },
          err => console.error(err)
        );
    }
  }

  getQuestion4Section(sections: SvSection[]) {
    sections.forEach((s, i) => {
      this.qService.get4Section(s.id.toString())
        .subscribe(
          res => {
            this.questions = res['data'];
            if (this.questions.length > 0) {
              s.questions = this.questions;
              this.getOptions4Question(s.questions, i);
            }
          },
          err => console.error(err)
        );
    });

  }

  getOptions4Question(question: Question[], i) {
    question.forEach((q, j) => {
      this.optService.get4question(q.id.toString())
        .subscribe(
          res => {
            let temp: Option[] = res['data'];
            if (temp.length > 0) {
              q.options = temp;
              this.getAxis4Options(q.options, j);
              temp = [];
            }
          },
          err => console.error(err)
        );
    });
  }

  getAxis4Options(option: Option[], i) {
    option.forEach((op, j) => {
      this.axService.get4Option(op.id.toString())
        .subscribe(
          res => {
            let temp: Axis[] = res['data'];
            if (temp.length > 0) {
              op.axis = temp;
            }
            temp = [];
          },
          err => console.error(err)
        );
    });
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idcreator: [null],
      idstatus: [''],
      name: [''],
      title: [''],
      isActive: [],
      questions: this.fb.array([
        this.fb.group({
          id: [null],
          idquestiontype: [null],
          idsurvey: [null],
          label: [''],
          summary: [''],
          detail: [''],
          order: [''],
          options: this.fb.array([
            this.fb.group({
              id: [null],
              idquestion: [null],
              label: [null],
              isMatrix: [null],
              axis: this.fb.array([
                this.fb.group({
                  id: [null],
                  idoptions: [null],
                  label: [''],
                  type: [],
                  detail: [''],
                  logo: [],
                  isActive: [],
                })
              ])
            })
          ])
        })
      ])
    });

  }

  showCompleteMessage() {
    this.toggleMessages(false);
  }

  hideMessage() {
    this.toggleMessages(true);
  }

  openGlossary() {
    const glossarySection = this.survey.sections.find(section => section.title === "Glosario de términos");
    if (glossarySection) {
      window.open(glossarySection.summary, '_blank');
    }
  }

  openGlossaryModal() {
    this.showModal = true;
    this.toggleMessages(false);
  }

  closeGlossaryModal() {
    this.showModal = false;
  }

  toggleMessages(isHovering: boolean) {
    const bubble = document.getElementById('bubble');
    const typingText = document.getElementById('typingText');
    const hoverMessage = document.getElementById('hoverMessage');

    if (typingText && hoverMessage && bubble) {
      if (isHovering) {
        typingText.classList.remove('show');
        setTimeout(() => {
          typingText.style.display = 'none';
          hoverMessage.style.display = 'block';
          hoverMessage.classList.add('show');
        }, 500); // Esperar a que se complete la transición
        bubble.classList.remove('full-text');
        bubble.classList.add('small-text');
      } else {
        hoverMessage.classList.remove('show');
        hoverMessage.style.display = 'none';
        typingText.style.display = 'block';
        setTimeout(() => {
          typingText.classList.add('show');
        }, 0); // Transición suave después de mostrar
        bubble.classList.remove('small-text');
        bubble.classList.add('full-text');
      }
    }
  }

  filterCareers(query: string, idquestion: number, idoption: number) {
    this.filteredCareers = this.careers.filter(career =>
      career.name.toLowerCase().includes(query.toLowerCase())
    );
    this.isCareersDropdownVisible = this.filteredCareers.length > 0;
    this.handleManualEntry(query, idquestion, idoption);
  }

  selectCareer(career: { id: number, name: string }, idquestion: number, idoption: number) {
    this.isCareersDropdownVisible = false;
    const inputElement = (document.getElementById(idoption.toString()) as HTMLInputElement);
    if (inputElement) {
      inputElement.value = career.name;
    }
  }

  handleManualEntry(query: string, idquestion: number, idoption: number) {
    if (!this.filteredCareers.length) {
    }
  }

  onFocusCareers() {
    this.isCareersDropdownVisible = this.filteredCareers.length > 0;
  }

  onBlurCareers() {
    setTimeout(() => { this.isCareersDropdownVisible = false; }, 200);
  }

  loadCountries(): void {
    this.http.get<{ countries: { id: number, name: string }[] }>('assets/json/countries.json')
      .subscribe(data => {
        this.countries = data.countries;
        this.filteredCountries = this.countries;
      });
  }

  loadStates(): void {
    this.http.get<{ states: { id: number, id_country: number, name: string }[] }>('assets/json/states.json')
      .subscribe(data => {
        this.states = data.states;
      });
  }

  filterCountries(query: string, idquestion: number, idoption: number): void {
    this.filteredCountries = this.countries.filter(country =>
      country.name.toLowerCase().includes(query.toLowerCase())
    );
    this.isCountriesDropdownVisible = this.filteredCountries.length > 0;
  }

  filterStates(query: string, idquestion: number, idoption: number): void {
    if (this.selectedCountryId) {
      this.filteredStates = this.states.filter(state =>
        state.id_country === this.selectedCountryId && state.name.toLowerCase().includes(query.toLowerCase())
      );
      this.isStatesDropdownVisible = this.filteredStates.length > 0;
    }
  }

  selectCountry(country: { id: number, name: string }, idquestion: number, idoption: number): void {
    this.selectedCountryId = country.id;
    this.isCountriesDropdownVisible = false;

    const countryInput = document.getElementById(idoption.toString()) as HTMLInputElement;
    if (countryInput) {
      countryInput.value = country.name;
    }

    this.filterStates('', idquestion, idoption);
  }

  selectState(state: { id: number, name: string }, idquestion: number, idoption: number): void {
    this.isStatesDropdownVisible = false;

    const stateInput = document.getElementById(idoption.toString()) as HTMLInputElement;
    if (stateInput) {
      stateInput.value = state.name;
    }

  }

  onFocusCountries(): void {
    this.isCountriesDropdownVisible = this.filteredCountries.length > 0;
  }

  onBlurCountries(): void {
    setTimeout(() => { this.isCountriesDropdownVisible = false; }, 200);
  }

  onFocusStates(): void {
    this.isStatesDropdownVisible = this.filteredStates.length > 0;
  }

  onBlurStates(): void {
    setTimeout(() => { this.isStatesDropdownVisible = false; }, 200);
  }

  isGlossaryAvailable(): boolean {
    return this.survey && this.survey.sections && !!this.survey.sections.find(section => section.title === "Glosario de términos");
  }

  hasAnswer(questionId: number): boolean {
    return this.answers[questionId] && Object.keys(this.answers[questionId]).length > 0;
  }


}
